import React from 'react'
import { DataTable } from 'primereact/datatable';
import {Column} from 'primereact/column';
import { Button } from 'primereact/button';
import DocumentImageService from '@/app/api/service/DocumentImageService';
import { STRINGS } from '@/app/constants/componentStrings';


function DocumentosOrcamento({documentos}){

    const visualizarDocTemplate = (rowData) => (
        <Button type="button" onClick={ e => { e.preventDefault();  DocumentImageService.visualizarDocumento('orcamento', rowData.id)} }
                icon="pi pi-download" 
                className="p-button-primary"
                style={{marginRight: '.5em'}}>
        </Button>
    )

    return(
        <DataTable value={documentos} emptyMessage={STRINGS.emptyMessage}>
            <Column field="descricaoTipoDocumento" header="Documento" />
            <Column field="nomeArquivo" header="Arquivo" />
            <Column  body={visualizarDocTemplate} className="coluna-acao"/>
        </DataTable>
    )
}

export default DocumentosOrcamento